import { INSERDAWA, GETDAWA, GETDAWAID, UPDATEDAWA, DELETEDAWA } from "../type";
const initialState = {
  Adddawa: [],
  Getdawa: [],
  GetdawaId: [],
  DeletedawaId: [],
  UpdatedawaId: [],

  loading: true,
};
const DawaR = (state = initialState, action) => {
  switch (action.type) {
    case GETDAWA:
      return {
        ...state,
        Getdawa: action.payload,
        loading: false,
      };
    case GETDAWAID:
      return {
        ...state,
        GetdawaId: action.payload,
        loading: false,
      };
    case INSERDAWA:
      return {
        Getdawa: state.Getdawa,
        Adddawa: action.payload,
        loading: false,
      };
    case DELETEDAWA:
      return {
        Getdawa: state.Getdawa,
        DeletedawaId: action.payload,
        loading: false,
      };
    case UPDATEDAWA:
      return {
        Getdawa: state.Getdawa,
        UpdatedawaId: action.payload,
        loading: false,
      };
    default:
      return state;
  }
};
export default DawaR;
